<script setup lang="ts">
import Checkbox from 'primevue/checkbox';
import type { IElement } from '~/interfaces/form/formBuilder';

const site = useSiteStore();
const props = defineProps<{ element: IElement }>();
const emits = defineEmits<{ (e: 'inputChange', id: string): void }>();
const model = defineModel<boolean>();

const handleChange = () => {
  emits('inputChange', props.element.id);
};
</script>

<template>
  <label
    :for="element.id"
    class="relative flex items-start cursor-pointer select-none"
  >
    <Checkbox
      v-model="model"
      :input-id="element.id"
      binary
      class="absolute top-0 left-0 mt-0.5"
      @change="handleChange"
    />
    <span
      class="pl-3 text-sm text-base-priority"
      v-html="
        $t(
          `label.${element.label}-${site.getRegionCode}`,
          `label.${element.label}`,
        )
      "
    />
  </label>
</template>
